import React from 'react';

const Header = ({titulo}) => { 
    return(
      <h1>{titulo}</h1>     
  );
};
 

export default Header;